import memoize from 'lodash/memoize';
import type { AssociatedField, OptionType } from '../../../../types/layout-items.tsx';
import type { Limits } from '../../../../types/validation.tsx';
import { isOptionsPerFieldLimitReached } from '../field-options/view.tsx';

export type GroupedCascadingOptions = {
	[key: string]: ReadonlyArray<OptionType>;
};
export const groupCascadingSelectFieldOptions: (
	options: ReadonlyArray<OptionType> | undefined,
) => GroupedCascadingOptions = memoize((options?: ReadonlyArray<OptionType>) => {
	if (!Array.isArray(options)) {
		throw new Error(
			'Expecting options array but options is not an array. (issue-type-page.field-options.dropdown-options)',
		);
	}

	return options.reduce<GroupedCascadingOptions>((grouped: GroupedCascadingOptions, option) => {
		const parentExternalUuid: string = option.parentExternalUuid || 'root';
		// eslint-disable-next-line no-param-reassign
		grouped[parentExternalUuid] = [...(grouped[parentExternalUuid] || []), option];
		return grouped;
	}, {});
});

export function canAddNewOptions(field: AssociatedField, limits: Limits) {
	return field.operations.canModifyOptions && !isOptionsPerFieldLimitReached(field, limits);
}
